import React, { useRef, useEffect } from 'react'
import { Menu } from 'antd';
import { Clock } from './apps/clock'
import app from './start'
import antd from 'xadmin-antd'
import ui from './ui/front'
import icons from './icon'
import model_extend from './plugins/model_extend'
import export_plugin from './plugins/export'
import auth from './apps/auth/frontIndex'
import cmdb from './apps/cmdb'

import user from './apps/user'
import clock from './apps/clock'
import settings from './apps/setting/front'
import components from './components'
import guide from './apps/guide/front'
import menu from './apps/menu'
import ws from './apps/ws'
import dashboard from './dashboard'
import datatag from './apps/datatag'
import Log from './apps/log'
import api from './api'
import systemvar from './apps/systemvar'
import license406 from './apps/406'
import permission417 from './apps/417'
import effects from './effects'
import wechatQrcode from './apps/wechatQrcode'
import loginNext from './apps/loginNext'

import CustomApp from './ui/frontLayout/CustomApp'
import moment from 'moment'
import { C } from 'xadmin-ui';

moment.locale('zh-cn')

const main = {
  config: {
    api,
    mqttHost: '/mqtt',
    router: 'hash',
    locale: {
      lng: 'zh_Hans', moment: 'zh-cn'
    },
    auth: {
      can_signin: false, can_signup: false, can_reset_password: false,
      persist_type: 'session-storage'
    },
    'auth.login.captcha': 'comm/get_captcha_code',
    date_format: {
      time: 'HH:mm:ss', date: 'YYYY-MM-DD', datetime: 'YYYY-MM-DD HH:mm:ss'
    },
    mediaUrl: '/rest',
    filter: {
      textDefaultSearch: true
    },
    isMobile: (function isMobile() {
      const userAgentInfo = navigator.userAgent
      const Agents = [
        'Android',
        'iPhone',
        'iPad',
        'iPod'
      ]
      let flag = false
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = true
          break
        }
      }
      return flag
    })()
  },
  context: (app) => (context, cb) => {
    const rs = app.get('routers')
    const { settings } = context.store?.getState()
    const routers = settings?.routers || []

    const findComponent = name => {
      if (name.startsWith('dashboard.')) {
        const id = name.substring(10)
        return ({ children }) => <CustomApp id={id} parentChildrens={children}></CustomApp>
      }
      return () => 'Not Found Component'
    }

    const convertRouter = r => {
      return {
        path: r.path,
        component: findComponent(r.element || r.component),
        childRoutes: (r.children || []).map(convertRouter)
      }
    }

    const childRoutes = routers && routers.map(convertRouter)
    const startRoutes = app._cache?.routers['/'] || []

    if (childRoutes.length > 0) {
      app._cache['routers'] = {
        ...app._cache?.routers,
        '@': [{
          path: '/',
          component: C.lazy('Main'),
          childRoutes,
          indexRoute: {
            onEnter: (_, replace) => replace({ pathname: '/app/dashboard' })
          },
        }]
      }
    }
    console.log(app._cache['routers'], 'app._cache');
    cb(null, context)
  },
  effects
}

const date_clock = {
  ...clock,
  blocks: {
    'top.right': ({ nodes }) => {
      nodes.unshift((
        <Menu.Item key="clock" style={{ lineHeight: '25px', fontSize: '.8em', height: 56, textAlign: 'center' }} >
          <Clock />
        </Menu.Item>
      ))
    }
  }
}

app['module'] = 'front'

export default app
  .unuse('xadmin.model.modalform')
  .use(settings)
  .use(date_clock)
  .use(license406)
  .use(permission417)
  .use(menu)
  .use(icons)
  .use(dashboard)
  .use(antd)
  .use(main)
  .use(model_extend)
  .use(export_plugin)
  .use(cmdb)
  .use(guide)
  .use(auth)
  .use(user)
  .use(ui)
  .use(components)
  .use(ws)
  .use(datatag)
  .use(Log)
  .use(systemvar)
  .use({ name: 'front' })
  .use(wechatQrcode)
  .use(loginNext)

